module.exports = __webpack_public_path__ + "img/1700_CourseComplete.69b249e9.png";